/**
 * 大宗交易页面验证码 — 一次性通行票据（按账号绑定）
 *
 * 每次进入大宗交易页面都必须重新输码：
 * - 验证页校验成功后 grantVerifyPass 发一张内存票据
 * - 列表页 onLoad 时 consumeVerifyPass 消费，用完即作废
 * - 不落 storage，刷新 / 重进 / 退出登录 / 换号都需重新输入
 */

// 旧版会话缓存 key，仅用于清理历史残留
const LEGACY_CACHE_KEYS = ['block_trading_page_verified_user', 'block_trading_page_verified'];

let passTicket = '';

/**
 * 用户维度 key：优先 token（登录/换号必变，且进页时一定有）
 * 再兜底 uid，避免无 token 的异常态
 */
export function getBlockTradeVerifyUserKey(userStore) {
	if (!userStore) return 'guest';
	if (userStore.token) return String(userStore.token);
	const info = userStore.userInfo || {};
	const uid = info.id ?? info.uid ?? info.userId ?? '';
	if (uid !== '' && uid != null) return String(uid);
	return 'guest';
}

/** 作废票据，并清理旧版残留缓存 */
export function clearBlockTradeVerifyCache() {
	passTicket = '';
	try {
		if (typeof sessionStorage !== 'undefined') {
			LEGACY_CACHE_KEYS.forEach((key) => sessionStorage.removeItem(key));
		}
	} catch (e) {}
	try {
		LEGACY_CACHE_KEYS.forEach((key) => uni.removeStorageSync(key));
	} catch (e) {}
}

/** 仅用户输码校验成功后发放，绑定当前账号 */
export function grantVerifyPass(userStore) {
	const userKey = getBlockTradeVerifyUserKey(userStore);
	passTicket = userKey === 'guest' ? '' : userKey;
}

/** 消费票据：本次进页是否刚校验过，调用后票据即作废 */
export function consumeVerifyPass(userStore) {
	const ticket = passTicket;
	passTicket = '';
	const userKey = getBlockTradeVerifyUserKey(userStore);
	return !!ticket && userKey !== 'guest' && ticket === userKey;
}

export function buildBlockTradeIndexUrl(options = {}) {
	const t = options.t || 1;
	const market = options.market || '';
	return `/pages/blockTrade/index?t=${t}&market=${market}`;
}

export function buildBlockTradeVerifyUrl(options = {}) {
	const t = options.t || 1;
	const market = options.market || '';
	return `/pages/blockTrade/verify?t=${t}&market=${market}`;
}
